import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const currentUserGroup = (state: IAppState) => state.userGroups.currentUserGroup;

export const getCurrentUserGroup = createSelector(
    currentUserGroup,
    (state: ICurrentUserGroupState) => state.currentGroup
);

export const selectIsLoadingUserGroup = createSelector(
    currentUserGroup,
    (state: ICurrentUserGroupState) => state.isLoading
);

export const getSpecificUsersList = createSelector(
    currentUserGroup,
    (state: ICurrentUserGroupState) => state.currentGroup.users
);

export const getViewStatus = createSelector(
    currentUserGroup,
    (state: ICurrentUserGroupState) => state.status
);
